import { useNavigate } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { useScale } from "common/utils";
import { TutorialArrow } from "common/assets";
import { Overlay } from "features/creator/tutorial/top/stages/Layout";

const Step = (props: { back: () => void; next: () => void; close: () => void }) => {
  const { close } = props;
  const { scale } = useScale();
  const navigate = useNavigate();
  const [panelRect, setPanelRect] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    setTimeout(() => {
      const panel = document.getElementById("app-back-btn");
      const rect = panel.getBoundingClientRect();
      setPanelRect({
        x: rect.x - 20 * scale,
        y: rect.y - 15 * scale,
        width: rect.height + 30 * scale,
        height: rect.height + 30 * scale,
      });
    }, 300);
  }, [scale]);

  const handleClick = useCallback(() => {
    close();
    navigate("/creator?is_tutorial_app=true");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Overlay area={panelRect} onClick={handleClick}>
      <div
        className="absolute z-50"
        style={{
          width: 108 * scale,
          height: 105 * scale,
          transform: `translate(${panelRect.x + panelRect.width}px, ${
            panelRect.y - 5 * scale
          }px) rotate(135deg)`,
        }}
      >
        <TutorialArrow />
      </div>
    </Overlay>
  );
};

export default Step;
